import _ from 'lodash';
import { getUniqueArray, flattenArray } from './dataFormatUtils';

export function getMetricSourceForRequest(metrics, request) {
    return metrics.find(
        (metric) => metric.uniqueRequestString === request.uniqueRequestString
    );
}

export function getMetricSourcesForRequests(metrics, requests) {
    return requests.map((request) =>
        getMetricSourceForRequest(metrics, request)
    );
}

export function allMetricSourcesAuthorized(
    metricSources,
    requireAllSources = true
) {
    if (requireAllSources) {
        return metricSources.every((source) => source.isAuthorized);
    }

    return metricSources.find((source) => source.isAuthorized);
}

// eslint-disable-next-line complexity
export function getMetricSourceErrors(metricSources, metricRequests) {
    return metricSources.reduce((result, source) => {
        if (source.errorMessage) {
            const metricRequest = metricRequests.find(
                (request) =>
                    request.uniqueRequestString === source.uniqueRequestString
            );
            result.push({
                key: metricRequest?.metricSourceKey,
                message: source.errorMessage,
                uniqueRequestString: source.uniqueRequestString,
            });
        }
        return result;
    }, []);
}

export function getErrorMessageToDisplay(error, friendlyMessage) {
    if (process.env.NODE_ENV === 'development') {
        return `${friendlyMessage} (${error.statusCode}: ${error.response})`;
    }

    return friendlyMessage;
}

export function displayMetricSourceError(error, dashboardLabels) {
    const errorMessage =
        process.env.NODE_ENV !== 'development'
            ? dashboardLabels.unableToRetrieveData
            : error.message;
    return `${error.key}: ${errorMessage}`;
}

export function hasMetricSources(metricSources, requireAllSources = true) {
    if (requireAllSources) {
        return metricSources.every((source) => source.metricSeries);
    }

    return metricSources.find((source) => source.metricSeries);
}

export function areGroupBysDifferent(metricRequests) {
    return metricRequests.some(
        (x) => !_.isEqual(x.groupBy, metricRequests[0].groupBy)
    );
}

export function areFirstGroupBysDifferent(metricRequests) {
    return metricRequests.some(
        (x) => !_.isEqual(x.groupBy[0], metricRequests[0].groupBy[0])
    );
}

export function isMetricSourceTruncated(metricSource) {
    return metricSource.isTruncated;
}

export function areMetricSourcesTruncated(metricSources) {
    return metricSources.some(isMetricSourceTruncated);
}

export function getAllMetricsFromMetricRequests(metricRequests) {
    return flattenArray(metricRequests.map((request) => request.metrics));
}

export function getAllMetricSeriesFromMetricSources(metricSources) {
    return flattenArray(
        metricSources.map((metricSource) => metricSource.metricSeries)
    );
}

export function getUniqueGroupsFromMetricSeries(metricSeries, groupBy) {
    return getUniqueArray(metricSeries.map((series) => series[groupBy]));
}
